<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid class="pa-0">
        <v-card class="green lighten-5 pa-1">            
            <Title :title="targetPlace.body.name">
                <v-spacer />
                <TitleButton
                    color="primary"
                    icon="mdi-keyboard-return"
                    name="一覧に戻る"
                    @click="targetPlace = null" />                
            </Title>
            <v-card-text class="pa-0">
                <v-tabs v-model="selectedTabIndex">
                    <v-tab>
                        <v-sheet label :color="selectedTabIndex == 0 ? 'green lighten-4' : 'transparent'" style="width:100%" class="pa-1" rounded="">
                            <h2 v-if="selectedTabIndex == 0">作業</h2>
                            <h3 v-else>作業</h3>
                        </v-sheet>
                    </v-tab>
                    <v-tab>
                        <v-sheet label :color="selectedTabIndex == 1 ? 'green lighten-4' : 'transparent'" style="width:100%" class="pa-1" rounded="">
                            <h2 v-if="selectedTabIndex == 1">環境</h2>
                            <h3 v-else>環境</h3>
                        </v-sheet>
                    </v-tab>
                    <v-tab-item>
                        <v-container fluid class="pa-0">
                            <v-row dense >
                                <v-col>
                                    <v-toolbar dense flat>
                                        <v-menu offset-y absolute close-on-content-click min-width="100" max-width="300">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    color="primary">
                                                    <v-icon>mdi-menu</v-icon>
                                                    機能メニュー
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-item :disabled="targetPlace.body.managementAgrichemical == null || !targetPlace.body.managementAgrichemical.enabled" @click="onSelectAgrichemicalState">
                                                    <v-list-item-icon><v-icon>mdi-pill</v-icon></v-list-item-icon>
                                                    <v-list-item-content>農薬使用状況</v-list-item-content>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-toolbar>
                                </v-col>
                            </v-row>
                            <v-row dense align="start" justify="center">
                                <v-col v-if="canBrowseWork" cols="12" xs="12" sm="12" md="12" lg="12" xl="6">
                                    <v-toolbar flat dense class="pa-0">
                                        <v-checkbox v-model="viewCompletedWork" hide-details>
                                            <template v-slot:label>
                                                <span class="caption black--text">終了した作業を表示</span>
                                            </template>
                                        </v-checkbox>
                                        <v-spacer />
                                        <v-btn color="primary" icon @click="monthlyWorkViewMode = monthlyWorkViewMode == 'chart' ? 'calendar' : 'chart'" >
                                            <v-icon v-if="monthlyWorkViewMode == 'chart'">mdi-calendar-blank-outline</v-icon>
                                            <v-icon v-if="monthlyWorkViewMode == 'calendar'">mdi-arrow-expand-horizontal</v-icon>
                                        </v-btn>
                                    </v-toolbar>
                                    <v-card class="ma-1 pa-1" outlined tile>
                                        <v-toolbar flat>
                                            <v-btn icon @click="onClickWorkChartPreviusMonth" color="primary">
                                                <v-icon>mdi-chevron-left-circle</v-icon>
                                            </v-btn>
                                            <v-select
                                                v-model="workChartMonth.year"
                                                :items="years"
                                                item-text="text"
                                                item-value="value"
                                                hide-details />
                                            <v-select
                                                v-model="workChartMonth.month"
                                                class="ml-2"
                                                :items="months"
                                                item-text="text"
                                                item-value="value"
                                                hide-details />
                                            <v-btn icon @click="onClickWorkChartNextMonth" color="primary">
                                                <v-icon>mdi-chevron-right-circle</v-icon>
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text class="pa-0">
                                            <div ref="work_chart_container" style="position:relative;">
                                                <WorkChart
                                                    v-if="monthlyWorkViewMode == 'chart'"
                                                    ref="workChart"
                                                    :container="$refs.work_chart_container"
                                                    :targetMonth="{year:workChartMonth.year, month:workChartMonth.month}"
                                                    :viewCompletedWork="viewCompletedWork"
                                                    :place="targetPlace"
                                                    :workTypes="workTypes" />
                                                <WorkCalendar
                                                    v-if="monthlyWorkViewMode == 'calendar'"
                                                    :targetMonth="{year:workChartMonth.year, month:workChartMonth.month}"
                                                    :viewCompletedWork="viewCompletedWork"
                                                    :place="targetPlace"
                                                    :workTypes="workTypes"
                                                    @onClickCalendarWorkRecord="onClickCalendarWorkRecord" />
                                            </div>
                                        </v-card-text>
                                    </v-card>
                                    <v-card class="ma-1 pa-1" outlined tile>
                                        <v-simple-table fixed-header dense>
                                            <thead>
                                                <tr>
                                                    <template v-if="!$vuetify.breakpoint.xs">
                                                        <th>作業名</th>
                                                        <th>開始予定日</th>
                                                        <th>終了予定日</th>
                                                        <th>状態</th>
                                                        <th></th>
                                                    </template>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="!$vuetify.breakpoint.xs">
                                                    <template v-for="work in targetPlace.works">
                                                        <tr :key="work.workID" @click="onSelectedWork(work)" v-if="getWorkState(work).value !=99 || viewCompletedWork" :class="workListRowStyle(work)">
                                                            <td class="pt-1 pb-1">
                                                                {{work.name}}<br/>
                                                                <span style="font-size:small">({{getWorkType(work.workTypeID).name}})</span>
                                                            </td>
                                                            <td>{{work.scheduleDate.startDate}}</td>
                                                            <td>{{work.scheduleDate.endDate}}</td>
                                                            <td>{{getWorkState(work).text}}</td>
                                                            <td>
                                                                <v-btn v-if="!isShareMode" icon x-small @click.stop="onClickDeleteScheduleWork(work)" color="warning"><v-icon>mdi-delete</v-icon></v-btn>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </template>                                        
                                                <template v-else>
                                                    <tr>
                                                        <td>
                                                            <v-container fluid class="pa-0">
                                                                <v-row dense>
                                                                    <v-col>
                                                                        <template v-for="work in targetPlace.works">                                                        
                                                                            <v-card :key="work.workID" v-if="getWorkState(work).value !=99 || viewCompletedWork" :class="'pa-2 mt-1 mb-1 caption '+workListRowStyle(work)" @click.stop="onSelectedWork(work)">
                                                                                <span class="font-weight-bold">{{work.name}}</span>
                                                                                <v-divider />
                                                                                <table>
                                                                                    <tr>
                                                                                        <td style="width:100%">
                                                                                            <span style="font-size:xx-small">(予定){{work.scheduleDate.startDate}}～{{work.scheduleDate.endDate}}</span><br/>
                                                                                        </td>
                                                                                        <td>
                                                                                            <span>{{getWorkState(work).text}}</span>
                                                                                        </td>
                                                                                        <td>
                                                                                            <v-btn v-if="!isShareMode" icon x-small @click.stop="onClickDeleteScheduleWork(work)" color="warning"><v-icon>mdi-delete</v-icon></v-btn>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>                                                            
                                                                            </v-card>
                                                                        </template>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <tr v-if="!isShareMode" @click.stop="onClickAddNewWork">
                                                    <td :colspan="!$vuetify.breakpoint.xs ? 6 : 3" style="text-align:left">
                                                        <v-btn class="mt-3 mb-3" label color="light-blue white--text">
                                                            <v-icon>mdi-plus-circle-outline</v-icon>
                                                            新しい作業を作成
                                                        </v-btn>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </v-simple-table>
                                    </v-card>
                                    <v-card class="ma-1" outlined tile>
                                        <div class="ma-2">
                                            <v-btn color="primary" class="ma-1" @click="onClickEditWork" :disabled="this.selectedWork == null || !canRecordWork || isShareMode">
                                                <v-icon>mdi-pencil-outline</v-icon>変更
                                            </v-btn>
                                            <v-btn color="primary" class="ma-1" @click="onClickCompleteWork" :disabled="this.selectedWork == null || this.selectedWork.isCompleted || !canRecordWork || isShareMode">
                                                <v-icon>mdi-check</v-icon>終了
                                            </v-btn>
                                        </div>
                                    </v-card>
                                </v-col>
                                <v-expand-transition>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="6" v-if="selectedWork != null">
                                        <v-card class="pa-1">
                                            <Title :title="selectedWork.name+'の作業記録'" dense />
                                            <v-card class="ma-1 pa-1" outlined tile>
                                                <v-simple-table fixed-header dense>
                                                    <thead>
                                                        <tr>
                                                            <th>記録日</th>
                                                            <template v-for="recordItem in getWorkType(selectedWork.workTypeID).recordItems">
                                                                <th v-if="!recordItem.disabled" :key="recordItem.recordNo">
                                                                    {{recordItem.name}}
                                                                </th>
                                                            </template>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <template v-for="record in selectedWork.records">
                                                            <tr :key="record.recordNo" @click="onSelectedWorkRecord(record)">
                                                                <td>{{record.date}}</td>
                                                                <template v-for="recordItem in getWorkType(selectedWork.workTypeID).recordItems">
                                                                    <td v-if="!recordItem.disabled" :key="recordItem.recordNo">
                                                                        <div v-html="getPlaceWorkRecordFormattedValue(record, recordItem)" />
                                                                    </td>
                                                                </template>
                                                                <td>
                                                                    <v-btn v-if="!isShareMode" color="warning" icon x-small @click.stop="onClickDeleteScheduleWorkRecordData(record)" ><v-icon>mdi-delete</v-icon></v-btn>
                                                                </td>
                                                            </tr>
                                                        </template>
                                                    </tbody>
                                                </v-simple-table>
                                                <v-btn color="light-blue white--text" class="ma-1" @click="onClickAddNewWorkRecord" :disabled="selectedWork.isCompleted || !canRecordWork">
                                                    <v-icon>mdi-file-document-edit-outline</v-icon>新しい作業記録を入力
                                                </v-btn>
                                            </v-card>
                                        </v-card>
                                    </v-col>
                                </v-expand-transition>
                            </v-row>
                        </v-container>                        
                    </v-tab-item>
                    <v-tab-item>
                        <v-container fluid class="pa-1">
                            <v-row dense >
                                <v-col>
                                    <v-toolbar dense flat>
                                        <v-btn
                                            color="primary"
                                            @click="onClickAddNewMeasureItem">
                                            <v-icon>mdi-plus-circle-outline</v-icon>
                                            新しい環境項目を追加
                                        </v-btn>
                                    </v-toolbar>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col v-if="canBrowseEnvironment" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">                        
                                    <SensorList v-if="sensors != null && sensors.length > 0" :sensors="sensors" />
                                </v-col>
                                <v-col>
                                    <v-card class="ma-1 pa-1" outlined tile>
                                        <div v-if="targetPlace.body.streamingURLs == null || targetPlace.body.streamingURLs.length == 0" style="width:100%; text-align:center" class="caption">カメラのストリーミングURLが指定されていません。</div>
                                        <div v-else style="width:100%; text-align:center;">
                                            <table style="width:100%">
                                                <tr><td colspan="3"><span class="caption">{{targetPlace.body.streamingURLs[currentStreamingURLIndex].url}}</span></td></tr>
                                                <tr>
                                                    <td style="width:64px">
                                                        <v-btn icon color="primary" v-if="currentStreamingURLIndex>0" @click="currentStreamingURLIndex--"><v-icon>mdi-skip-previous-outline</v-icon></v-btn>
                                                    </td>
                                                    <td>
                                                        <img 
                                                            v-if="targetPlace.body.streamingURLs[currentStreamingURLIndex].type == 2"
                                                            :src="targetPlace.body.streamingURLs[currentStreamingURLIndex].url" 
                                                            :style="$vuetify.breakpoint.xs ? 'width:200px' : 'width:400px'"/>
                                                        <StreamViewer1
                                                            v-if="targetPlace.body.streamingURLs[currentStreamingURLIndex].type == 1" 
                                                            :url="targetPlace.body.streamingURLs[currentStreamingURLIndex].url" />
                                                        <StreamViewer2
                                                            v-if="targetPlace.body.streamingURLs[currentStreamingURLIndex].type == 3" 
                                                            :url="targetPlace.body.streamingURLs[currentStreamingURLIndex].url" />
                                                    </td>
                                                    <td style="width:64px;">
                                                        <v-btn icon color="primary" v-if="currentStreamingURLIndex<targetPlace.body.streamingURLs.length - 1" @click="currentStreamingURLIndex++"><v-icon>mdi-skip-next-outline</v-icon></v-btn>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                </v-tabs>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
        <Work 
            ref="work" 
            :states="workStates"
            :workTypes="workTypes"
            @onUpdatedTargetPlaceWork="onUpdatedTargetPlaceWork" />
        <WorkRecorder
            ref="workRecorder"
            :place="targetPlace"
            :workTypes="workTypes"
            :composts="composts"
            :fertilizeries="fertilizeries"
            :pesticides="pesticides" />
        <MeasureRecorder 
            ref="measureRecord" 
            :measureItems="measureItems"
            :place="targetPlace"
            @onUpdatedMeasureValue="onUpdatedMeasureValue"/>
        <MeasureItem 
            ref="measureItem"
            :measureItems="measureItems"
            :place="value"
            :boxes="boxes" />
        <AgrichemicalState
            ref="agrichemicalState" />
    </v-container>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }
    Date.prototype.addDay = function (v) {
        this.setDate(this.getDate()+v)
        return this
    }

    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import Work from '@/components/place/MaintenancePlaceWork';
    import WorkChart from '@/components/place/ChartPlaceWork';
    import WorkCalendar from '@/components/place/CalendarPlaceWork';
    import EnvironmentChart from '@/components/place/ChartEnvironment';
    import WorkRecorder from '@/components/place/RecorderPlaceWork'
    import MeasureRecorder from '@/components/place/RecorderMeasureValue';
    import MeasureItem from '@/components/place/MaintenanceMeasureItem';
    import StreamViewer1 from '@/components/tools/RTSPStreamViewer1';
    import StreamViewer2 from '@/components/tools/RTSPStreamViewer2';
    import DatePicker from '@/components/tools/DatePicker';
    import AgrichemicalState from '@/components/place/AgrichemicalState';
    import Confirm from '@/components/tools/ConfirmDialog';
    import SensorList from '@/components/box/SensorList';

    export default {
        components: {
            Title,
            TitleButton,
            Work,
            WorkChart,
            WorkCalendar,
            EnvironmentChart,
            WorkRecorder,
            MeasureRecorder,
            MeasureItem,
            StreamViewer1,
            StreamViewer2,
            DatePicker,
            AgrichemicalState,
            SensorList,
            Confirm
        },
        props: {
            /**
             * 対象の場所
             * {
             *      body: 場所,
             *      works[]: この場所に登録されている全作業
             * }
             */
            value: null,
            /**
             * 登録されている全作業種類
             */
            workTypes: null,
            /**
             * 登録されている全測定項目
             * {
             *     body: 実体,
             *     isVisible: 環境チャートに表示するか否か, 
             *     viewAxis: 1 or 2 表示するY軸
             *     histories: {
             *         年月: {
             *             日:測定データ
             *         }
             *     }
             * }
             */
            measureItems: null,
            /**
             * 登録されている全堆肥
             */
            composts: null,
            /**
             * 登録されている全肥料
             */
            fertilizeries: null,
            /**
             * 登録されている全農薬
             */
            pesticides: null,
        },
        computed: {
            /**
             * ログインしているユーザーのユーザーUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * 参照中のユーザーUID
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * 対象の場所
             */
            targetPlace: {
                get: function () {
                    return this.$props.value
                },
                set: function (value) {
                    this.$emit("input", value)
                }
            },
            /**
             * 共有モード
             */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /**
             * 共有モードの全種類
             */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
             */
            shareUserGroupMyUserData: function () {
                return this.$store.getters["managementItems/shareUserGroupMyUserData"]
            },
            /**
             * 作業の参照権限があるか否か
             */
            canBrowseWork: function () {
                // if (!this.isShareMode) return true
                // return this.mi_checkGroupUserAuthority(this.targetPlace.body, ["browse", "work"])
                return this.checkAuthority(["browse", "work"])
            },
            /**
             * 作業記録の権限があるか否か
             */
            canRecordWork: function () {
                // if (!this.isShareMode) return true
                // return this.mi_checkGroupUserAuthority(this.targetPlace.body, ["browse", "work", "work.record"])
                return this.checkAuthority(["browse", "work", "work.record"])
            },
            /**
             * 環境の参照権限があるか否か
             */
            canBrowseEnvironment: function () {
                // if (!this.isShareMode) return true
                // return this.mi_checkGroupUserAuthority(this.targetPlace.body, ["browse", "environment"])
                return this.checkAuthority(["browse", "environment"])
            },
            /**
             * 環境記録の権限があるか否か
             */
            canRecordEnvironment: function () {
                // if (!this.isShareMode) return true
                // return this.mi_checkGroupUserAuthority(this.targetPlace.body, ["browse", "environment", "environment.record"])
                return this.checkAuthority(["browse", "environment", "environment.record"])
            },
            /**
             * 場所に設定されている全農薬
             */
            targetAgrichemicalItems: function () {
                const agrichemical = this.$store.getters["managementItems/agrichemicals"].find((v)=>v.body.target == this.targetPlace.body.managementAgrichemical.target)
                return agrichemical.items
            },
            /**
             * 指定された権限を全て持つか否かを返す(共有中ではない時は、必ず True。共有中はチェック結果を返す)
             */
            checkAuthority: function () {
                return function (authorities) {
                    const self = this
                    if (!self.isShareMode) {
                        return true
                    }

                    if (self.targetPlace.authorities == null) {
                        return false
                    }

                    const groupAuthorities = self.targetPlace.authorities.find((v)=>v.ownerUserUID == self.shareUserGroupMyUserData.ownerUserUID && v.groupNo == self.shareUserGroupMyUserData.groupNo)
                    const userAuthorities = groupAuthorities != null ? groupAuthorities.users[self.loggedInUserUID] : null

                    // console.log("checkAuthority", place, this.shareUserGroupMyUserData, this.loggedInUserUID, groupAuthorities, userAuthorities)

                    if (userAuthorities != null) {
                        for (var authority of authorities) {
                            if (userAuthorities.findIndex((v)=>v == authority) < 0) {
                                console.log("user authority", authority, "deny!!")
                                return false
                            }
                            console.log("user authority", authority, "allow!!")
                        }
                        console.log("user authority", "all allow!!", authorities, userAuthorities)
                        return true
                    }

                    if (self.mi_checkGroupUserAuthority(self.targetPlace.body, authorities)){
                        return true
                    }
                    return false
                }
            },
            /**
             * 測定項目に設定されている環境ボックスのセンサーが格納された配列
             */
            sensors: function () {
                const self = this
                const list = []
                this.measureItems.forEach(function(item){
                    if (item.body.auto) {
                        const box = self.boxes.find((v)=>v.master.boxIdentificationCode == item.body.autoSetting.boxIdentificationCode)
                        // console.log("Place","sensors", self.boxes, box)
                        if (box != null) {
                            const sensor = box.sensors.find((v)=>v.body.sensorKey == item.body.autoSetting.sensorKey)
                            if (sensor != null) {
                                list.push(sensor)
                                console.log("Place","sensors", "add sensor", sensor, list)
                            } else {
                                console.log("unknown sensor", box.sensors, item.body.autoSetting.sensorKey)
                            }
                        }
                    }
                })
                return list
            }
        },
        watch: {
            viewCompletedWork: function () {
                // this.refreshWorkChartHeight()
            },
            "targetPlace.works": {
                handler: function (value, old) {
                    // console.log("targetPlace.works changed")
                    // this.refreshWorkChartHeight()
                },
                deep: true
            }
        },
        data: function () {
            return {
                /**
                 * チャートの表示月選択用の年と月
                 */
                years: [],
                months: [],                
                /**
                 * 作業の状態
                 */
                workStates: [
                    {value:1, text:"開始前"},           // 作業記録なしで、現在の日付が開始予定より前
                    {value:2, text:"作業期間内"},       // 作業記録なしで、現在の日付が予定範囲内
                    {value:3, text:"作業期間超え"},     // 作業記録なしで、現在の日付が終了予定より後
                    {value:4, text:"作業中"},           // 作業記録ありで、終了未設定
                    {value:99, text:"終了"},            // 終了設定
                ],
                /**
                 * 終了した作業を表示(True)/非表示
                 */
                viewCompletedWork: false,
                /**
                 * 一覧で選択されている作業
                 */
                selectedWork: null,
                /**
                 * 作業チャートの表示対象月
                 */
                workChartMonth: {
                    year: 2020,
                    month: 8
                },
                /**
                 * 測定チャートの表示範囲
                 */
                measureChartRanges: [
                    {value:"month", text:"月"},
                    {value:"day", text:"日"},
                    {value:"day_range", text:"日範囲"},
                ],
                /**
                 * 測定チャートの表示条件
                 */
                measureChartCondition: {
                    range: "month",
                    year: 2020,
                    month: 8,
                    date: "",
                    dateFrom: "",
                    dateTo: ""
                },
                /**
                 * 測定チャートのデータ取得中か否か(True:取得中)
                 */
                measureChartDataProcessing: false,
                /**
                 * 選択された測定項目
                 */
                selectedMeasureItem: null,
                /**
                 * Y1軸に選択された測定項目
                 */
                measureItemY1: null,
                /**
                 * Y2軸に選択された測定項目
                 */
                measureItemY2: null,
                /**
                 * 現在表示中のストリーミングのインデックス
                 */
                currentStreamingURLIndex: 0,
                /**
                 * 環境を表示するか否か
                 */
                isViewEnvironment: true,
                /**
                 * 月作業の表示モード
                 */
                monthlyWorkViewMode: "calendar",
                /**
                 * 環境ボックス
                 */
                boxes: [],
                /**
                 * 選択されているタブのインデックス
                 */
                selectedTabIndex: 0
            }
        },
        created: async function () {
            // console.log("Place", "created")
            const userUID = this.$store.getters["userUID"]
            const self = this
            /**
             * 年月のコンボボックス初期化
             */
            for (var year = 2020; year<=2100; year++) {
                this.years.push(
                    {value: year, text: year+"年"}
                )
            }
            for (var month = 1; month<=12; month++) {
                this.months.push(
                    {value: month, text: month+"月"}
                )
            }
            /**
             * 作業チャートと測定チャートの表示対象年月の初期設定(当月)
             */
            const d = new Date()
            this.workChartMonth.year = d.getFullYear()
            this.workChartMonth.month = d.getMonth() + 1
            this.measureChartCondition.range = "month"
            this.measureChartCondition.year = d.getFullYear()
            this.measureChartCondition.month = d.getMonth() + 1            
            this.measureChartCondition.date = d.toFormatString("yyyy-MM-dd")
            this.measureChartCondition.dateFrom = d.toFormatString("yyyy-MM-dd")
            this.measureChartCondition.dateTo = d.toFormatString("yyyy-MM-dd")
            /**
             * 環境ボックス取得
             */
            this.boxes = []
            console.log("環境ボックス", this.boxes)
            db.collection("users").doc(this.userUID).collection("boxes").get().then(function(snapShot) {
                snapShot.forEach(function(doc) {
                    const box = doc.data()
                    db.collection("environments").doc(box.boxIdentificationCode).get().then(function(docMaster) {
                        const master = docMaster.data()
                        const boxData = {
                            box: box,
                            master: master,
                            sensors: []
                        }
                        master.sensors.forEach(function(sensor) {
                            const sensorData = {
                                boxMaster: master,
                                body: sensor,
                                isVisible: true,
                                yAxis: 1,
                                measureInformation: null,
                                alarmHistories: [],
                                chart: null
                            }
                            boxData.sensors.push(sensorData)
                        })
                        self.boxes.push(boxData)
                        console.log("Place","created", "box", boxData)

                    }).catch (function (error) {
                        self.mi_writeLog("BoxManager/created", "BOXマスターの取得に失敗しました。("+error+")")
                    })
                })
            })
        },
        mounted: function () {
        },
        methods: {
            /**
             * 作業の前月ボタン押下時
             */
            onClickWorkChartPreviusMonth: function () {
                if (this.workChartMonth.month == 1) {
                    this.workChartMonth.year--
                    this.workChartMonth.month = 12
                } else {
                    this.workChartMonth.month--
                }
            },
            /**
             * 作業の翌月ボタン押下時
             */
            onClickWorkChartNextMonth: function () {
                if (this.workChartMonth.month == 12) {
                    this.workChartMonth.year++
                    this.workChartMonth.month = 1
                } else {
                    this.workChartMonth.month++
                }
            },
            /**
             * 測定チャートの前月ボタン押下時
             */
            onClickMeasureChartPreviusMonth: function () {
                if (this.measureChartCondition.month == 1) {
                    this.measureChartCondition.year--
                    this.measureChartCondition.month = 12
                } else {
                    this.measureChartCondition.month--
                }
            },
            /**
             * 測定チャートの翌月ボタン押下時
             */
            onClickMeasureChartNextMonth: function () {
                if (this.measureChartCondition.month == 12) {
                    this.measureChartCondition.year++
                    this.measureChartCondition.month = 1
                } else {
                    this.measureChartCondition.month++
                }
            },
            /**
             * 測定チャートの前日ボタン押下時
             */
            onClickMeasureChartPreviusDay: function () {
                this.measureChartCondition.date = (new Date(this.measureChartCondition.date)).addDay(-1).toFormatString("yyyy-MM-dd")
            },
            /**
             * 測定チャートの翌日ボタン押下時
             */
            onClickMeasureChartNextDay: function () {
                this.measureChartCondition.date = (new Date(this.measureChartCondition.date)).addDay(1).toFormatString("yyyy-MM-dd")
            },
            /**
             * 作業選択時
             */
            onSelectedWork: function (work) {
                // if (this.selectedWork == work) {
                //     this.selectedWork = null
                // } else {
                //     this.selectedWork = work
                // }
                this.selectedWork = work
            },
            /**
             * 作業一覧の作業予定削除ボタン押下時
             */
            onClickDeleteScheduleWork: function (work) {
                // console.log("onClickDeleteScheduleWork", work)
                const self = this
                this.$refs.confirm.show({
                    title: "作業予定の削除",
                    message: "この作業予定とこの作業で行った記録を全て削除しますか？<br/>※削除すると元に戻す事は出来ません。<br/>可能であれば削除せずに、'終了' で対応される事をお勧めします。",
                    buttonYes: "削除する",
                    buttonNo: "いいえ",
                    icon: "mdi-alert",
                    width: 500,
                    listenerYes: function () {
                        self.deleteWork(work)
                        return true
                    },
                })
            },
            /**
             * 新しい作業登録ボタン押下時
             */
            onClickAddNewWork: function () {
                this.$refs.work.show(this.targetPlace)
            },
            /**
             * 作業内容の変更ボタン押下時
             */
            onClickEditWork: function () {
                this.$refs.work.show(this.targetPlace, this.selectedWork)
            },
            /**
             * 作業終了ボタン押下時
             */
            onClickCompleteWork: function () {
                const self = this
                this.$refs.confirm.show({
                    title: "作業の終了",
                    message: "選択されている作業を終了します。<br/>この作業に対して作業記録は行えなくなりますが<br/>終了しますか？",
                    buttonYes: "終了する",
                    buttonNo: "いいえ",
                    width: 450,
                    listenerYes: function () {
                        self.completeWork()
                        return true
                    },
                })
            },
            /**
             * 作業記録選択時
             */
            onSelectedWorkRecord: function (record) {
                this.$refs.workRecorder.show(this.targetPlace, this.workTypes, this.selectedWork, record)
            },
            /**
             * 作業記録の削除ボタン押下時
             * 一旦記録画面を表示して、そこで削除を確認する
             */
            onClickDeleteScheduleWorkRecordData: function (record) {
                this.$refs.workRecorder.show(this.targetPlace, this.workTypes, this.selectedWork, record, true)
            },
            /**
             * カレンダー上の作業記録押下時
             */
            onClickCalendarWorkRecord: function (params) {
                // params: {
                //     work:
                //     record
                // }
                this.selectedWork = params.work
                this.onSelectedWorkRecord(params.record)
            },
            /**
             * 測定項目の削除ボタン押下時
             */
            onClickDeleteMeasureItem: function (measureItem) {
                const self = this
                // console.log("onClickDeleteMeasureItem", measureItem)
                if (measureItem.body.auto) {
                    this.$refs.confirm.show({
                        title: "測定項目の削除",
                        message: "自動測定の測定項目は、ここから削除出来ません。<br/>お申し込み下さい。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 450,
                    })
                } else {
                    this.$refs.confirm.show({
                        title: "作業の終了",
                        message: "測定項目 " + measureItem.body.name + " を削除しますか？<br/>この測定項目の過去の測定値も全て削除され、元には戻せません。<br/>本当に削除しますか？",
                        icon: "mdi-alert",
                        buttonYes: "削除する",
                        buttonNo: "いいえ",
                        width: 500,
                        listenerYes: function () {
                            self.deleteMeasureItem(measureItem)
                            return true
                        },
                    })
                }
            },
            /**
             * 作業記録ボタン押下時
             */
            onClickAddNewWorkRecord: function () {
                this.$refs.workRecorder.show(this.targetPlace, this.workTypes, this.selectedWork)
            },
            /**
             * 新しい測定項目ボタン押下時
             */
            onClickAddNewMeasureItem: function () {
                this.$refs.measureItem.show()
            },
            /**
             * 測定項目の変更ボタン押下時
             */
            onClickEditMeasureItem: function () {
                this.$refs.measureItem.show(this.selectedMeasureItem)
            },
            /**
             * 測定記録ボタン押下時
             */
            onClickRecordMeasureValue: function () {
                this.$refs.measureRecord.show(this.selectedMeasureItem)
            },
            /**
             * 測定記録のダイアログにおいて、測定値が変更された時
             */
            onUpdatedMeasureValue: function () {
                this.$refs.environmentChart.refresh()
            },
            /**
             * 現在選択されている場所に、作業が登録/更新された時
             */
            onUpdatedTargetPlaceWork: function (work) {
                // console.log("onUpdatedTargetPlaceWork", work)
                const self = this

                // this.$refs.workChart.refresh() !!!
            },
            /**
             * 農薬使用状況選択時
             */
            onSelectAgrichemicalState: function () {
                this.$refs.agrichemicalState.show(this.targetPlace)
            },
            /**
             * 選択されている作業を作業終了に設定する。
             */
            completeWork: function () {
                const self = this
                db.collection("users").doc(this.userUID).collection("places").doc(this.selectedWork.placeID + "").collection("works").doc(this.selectedWork.workID + "").update(
                    {
                        "isCompleted": true,
                        "updater.userUID": this.$store.getters["loggedInUserUID"],
                        "updater.dateTime": this.df_currentDateTime()
                    }
                ).then (function() {
                    self.selectedWork.isCompleted = true
                    self.selectedWork.updater = {
                        userUID: self.$store.getters["loggedInUserUID"],
                        dateTime: self.df_currentDateTime()
                    }
                    self.selectedWork = null
                    self.$store.commit("notification", {message:"予定を終了に設定しました。", isError:false})                    
                }).catch (function(error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"予定の更新に失敗しました。", isError:true})
                    self.mi_writeLog("Place/completeWork", "予定の更新に失敗しました。("+error+")")
                })
            },
            /**
             * 作業一覧の作業ごとのスタイル
             */
            workListRowStyle: function (work) {
                if (this.selectedWork != null && work.workID == this.selectedWork.workID) {
                    return "light-green lighten-4"
                }
                return "white"
            },
            /**
             * 指定された作業を削除
             */
            deleteWork: function (work) {
                const userUID = this.$store.getters["userUID"]
                const self = this

                db.collection("users").doc(userUID)
                .collection("places").doc(""+self.targetPlace.body.placeID)
                .collection("works").doc(work.workID).delete().then(function(){
                    
                    self.$store.commit("notification", {message:"作業を削除しました。", isError:false})

                    // 配列からの削除は監視ロジック側で行うので、ここのロジックは削除
                    // const index = self.targetPlace.works.findIndex((v)=>v.workID == work.workID)
                    // self.targetPlace.works.splice(index, 1)                    
                    // console.log("配列から作業を削除")

                    // self.$refs.workChart.refresh() !!!
                    self.selectedWork = null
                }).catch(function(error){
                    self.$store.commit("notification", {message:"作業の削除に失敗しました。", isError:true})
                    self.mi_writeLog("Place/deleteWork", "作業の削除に失敗しました。("+error+")")
                })
            },
            /**
             * 指定された測定項目を削除
             */
            deleteMeasureItem: function (measureItem) {
                const userUID = this.$store.getters["userUID"]
                const self = this

                const base = db.collection("users").doc(userUID)
                .collection("places").doc(""+measureItem.body.placeID)
                .collection("environments").doc(measureItem.body.measureItemID+"")
                
                base.delete().then(function(){
                    self.$store.commit("notification", {message:"測定項目を削除しました。", isError:false})
                    const index = self.measureItems.findIndex((v)=>v.body.measureItemID == measureItem.body.measureItemID)
                    self.measureItems.splice(index, 1)
                    self.selectedMeasureItem = null
                    /**
                     * 測定値の履歴を削除
                     */
                    base.collection("histories").get().then(function(snapShot){
                        snapShot.forEach(function(doc){
                            const history = doc.data()
                            base.collection("histories").doc(history.date).delete().then(function(){
                            }).catch (function(error) {
                                console.log(error)
                                self.$store.commit("notification", {message:"測定項目の履歴の削除に失敗しました。", isError:true})
                                self.mi_writeLog("Place/deleteMeasureItem", "測定項目の履歴の削除に失敗しました。("+error+")")
                            })
                        })
                    })
                }).catch(function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"測定項目の削除に失敗しました。", isError:true})
                    self.mi_writeLog("Place/deleteMeasureItem", "測定項目の削除に失敗しました。("+error+")")
                })
            },
            /**
             * 指定されたIDをもつ作業種類を取得
             */
            getWorkType: function (id) {
                // console.log("workItem", id, this.workTypes)
                const index = this.workTypes.findIndex((v)=>v.workTypeID == id)
                if (index < 0) {
                    return {
                        workTypeID: id,
                        name: "unknown"
                    }
                }
                return this.workTypes[index]
            },
            /**
             * 指定された作業の状態を取得
             */
            getWorkState: function (work) {
                const currentDate = this.df_currentDateTime("yyyy-MM-dd")

                // 終了が設定されている時は、終了
                if (work.isCompleted) {
                    return this.workStates[4]
                }

                if (work.records == null || work.records.length == 0) {
                    // 作業記録無し
                    // 開始予定未設定の時は、作業期間内
                    if (work.scheduleDate.startDate == null || work.scheduleDate.startDate == '') {
                        return this.workStates[1]
                    }
                    // 現在<開始予定の時は、開始前
                    if (currentDate < work.scheduleDate.startDate) {
                        return this.workStates[0]
                    }
                    // 終了予定未設定の時は、作業期間内
                    if (work.scheduleDate.endDate == null || work.scheduleDate.endDate == '') {
                        return this.workStates[1]
                    }
                    // 現在>終了予定の時は、期間超え
                    if (currentDate > work.scheduleDate.endDate) {
                        return this.workStates[2]
                    }
                    // 上記以外の時は、作業期間内
                    return this.workStates[1]
                }

                // 作業記録がある時は、作業中
                return this.workStates[3]
            },
            /**
             * 指定されたカテゴリーで、指定されたIDの堆肥データを返す
             */
            getCompost: function (categoryID, id) {
                const i = this.composts.findIndex((v)=>v.categoryID == categoryID)
                if (i < 0) return "unknown"
                const j = this.composts[i].items.findIndex((v)=>v.id == id)
                if (j < 0) return "unknown"
                return this.composts[i].items[j]
            },
            /**
             * 指定されたカテゴリーで、指定されたIDの肥料データを返す
             */
            getFertilizer: function (categoryID, id) {
                const i = this.fertilizeries.findIndex((v)=>v.categoryID == categoryID)
                if (i < 0) return "unknown"
                const j = this.fertilizeries[i].items.findIndex((v)=>v.id == id)
                if (j < 0) return "unknown"
                return this.fertilizeries[i].items[j]
            },
            /**
             * 指定されたカテゴリーで、指定されたIDの農薬データを返す
             */
            getPesticide: function (categoryID, id) {
                const i = this.pesticides.findIndex((v)=>v.categoryID == categoryID)
                if (i < 0) return "unknown"
                const j = this.pesticides[i].items.findIndex((v)=>v.id == id)
                if (j < 0) return "unknown"
                return this.pesticides[i].items[j]
            },
            /**
             * 場所作業の記録値を一覧に表示する値にして返す
             */
            getPlaceWorkRecordFormattedValue: function (record, recordItem) {

                const value = record.values.find((v)=>v.recordNo == recordItem.recordNo)

                if (value == null || value.value == '') {
                    return "-----"
                }

                /** 記録項目から値を返す */
                var categoryItem = null
                switch (recordItem.type) {
                    case 1:
                        /** 数値 */
                        return value.value + (recordItem.data != null && recordItem.data.unit != null ? recordItem.data.unit : "")
                    case 2:
                        /** 文字列 */
                        return value.value
                    case 3:
                        /** 日付 */
                        return value.value
                    case 4:
                        /** 時刻 */
                        return value.value
                    case 5:
                        /** 日時 */
                        return value.value
                    case 6:
                        /** 選択 */
                        return value.value      // !!!!!
                    case 7:
                        /** 堆肥 */
                        categoryItem = this.getCompost(value.value.categoryID, value.value.id)
                        if (categoryItem == "unknown") return "unknown"
                        return categoryItem.name
                    case 8:
                        /** 肥料 */
                        categoryItem = this.getFertilizer(value.value.categoryID, value.value.id)
                        if (categoryItem == "unknown") return "unknown"
                        return categoryItem.name
                    case 9:
                        /** 農薬(旧) */
                        categoryItem = this.getPesticide(value.value.categoryID, value.value.id)
                        if (categoryItem == "unknown") return "unknown"
                        return categoryItem.name
                    case 10:
                        // console.log("農薬使用データ", record, recordItem, this.targetPlace)
                        const agrichemicalNames = []
                        for (var i=0; i<value.value.length; i++) {
                            agrichemicalNames.push(this.targetAgrichemicalItems[value.value[i].agrichemicalNo].name)
                        }
                        return agrichemicalNames.join("+")
                    case 11:
                        return "出荷:"+value.value.shipment + " <br/> " + "販売:"+value.value.sales
                    case 12:
                        if (value.value.sickNo == null) {
                            return value.value.sickName
                        }
                        return this.$store.getters["managementItems/sicks"].list[value.value.sickNo].name
                    case 13:
                        if (value.value.verminNo == null) {
                            return value.value.verminName
                        }
                        return this.$store.getters["managementItems/vermins"].list[value.value.verminNo].name
                }
            }
        }
    }
</script>
